export default __webpack_public_path__ + "static/media/casino-logo.453f3791.png";